'use client';

import { c as _c } from "react/compiler-runtime";
import { SessionProvider } from 'next-auth/react';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { QueryClientContext } from '@contexts';
import { UserContextProvider } from '@lib/auth/UserContextProvider';
import { TimeEnum } from '@lib/enums';
import { JotaiStoreProvider } from '@lib/states/JotaiStoreProvider';
import type { FC, ReactNode } from 'react';
type Props = Readonly<{
  children: ReactNode;
}>;
export const ContextTree: FC<Props> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <NuqsAdapter><JotaiStoreProvider><QueryClientContext><SessionProvider refetchInterval={TimeEnum.OneMinuteInSeconds}><UserContextProvider>{children}</UserContextProvider></SessionProvider></QueryClientContext></JotaiStoreProvider></NuqsAdapter>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};